import { render } from "./PosOrderListComponent.vue?vue&type=template&id=180a59f4&scoped=true"
import script from "./PosOrderListComponent.vue?vue&type=script&lang=js"
export * from "./PosOrderListComponent.vue?vue&type=script&lang=js"

import "./PosOrderListComponent.vue?vue&type=style&index=0&id=180a59f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180a59f4"],['__file',"resources/js/components/admin/posOrders/PosOrderListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "180a59f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('180a59f4', __exports__)) {
    api.reload('180a59f4', __exports__)
  }
  
  module.hot.accept("./PosOrderListComponent.vue?vue&type=template&id=180a59f4&scoped=true", () => {
    api.rerender('180a59f4', render)
  })

}


export default __exports__